import axios from 'axios';
import config from '../../config.json';
import { getApiBaseUrl } from './AppEnvironment';


const WebAPI = axios.create({        
    baseURL: getApiBaseUrl(),
    timeout: config.REQUEST_TIMEOUT,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true
});

WebAPI.CancelToken = axios.CancelToken;
WebAPI.isCancel = axios.isCancel;

export default WebAPI;